import styled from "styled-components";

export const Thumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;

  cursor: zoom-in;
`;

export const ThumbnailImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: inherit;
`;

export const UnavailableImageMessage = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  line-height: normal;
`;

export const Shade = styled.div<{ $visible: boolean }>`
  background-color: rgba(0, 0, 0, 0.5);

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 2rem;

  display: ${(p) => (p.$visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  z-index: 2;

  cursor: zoom-out;
`;

export const FullSizeImageWrapper = styled.div`
  position: relative;
  line-height: 0;
  width: min(calc(100dvw - 4rem), calc((100dvh - 4rem) * (16 / 9)));
  height: min(calc(100dvh - 4rem), calc((100dvw - 4rem) * (9 / 16)));
  display: flex;
  cursor: zoom-out;
`;

export const FullSizeImage = styled.img`
  height: 100%;
`;

export const VideoWrapper = styled.div`
  position: relative;
  line-height: 0;
  width: min(calc(100dvw - 4rem), calc((100dvh - 4rem) * (16 / 9)));
  height: min(calc(100dvh - 4rem), calc((100dvw - 4rem) * (9 / 16)));
  display: flex;
`;

export const FullSizeVideo = styled.video`
  height: 100%;
  width: 100%;
  aspect-ratio: 16 / 9;
  cursor: default;
`;

export const FullSizeButtonContainer = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  display: flex;
  gap: 0.5rem;
  z-index: 1;
`;

const ActionButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;

  color: ${(p) => p.theme.color.palette.concreteGrey};
  background: rgba(10, 10, 10, 0.45);
  box-shadow: #ffffff0a 0px 0px 2px 4px;
  border-radius: 4px;
  width: 2.25rem;
  height: 2.25rem;
  backdrop-filter: blur(6px);
  transition:
    background 0.15s,
    border-color 0.15s;
  &:hover {
    background: rgba(10, 10, 10, 0.8);
    color: ${(p) => p.theme.color.palette.white};
  }
`;

export const ZoomButton = styled(ActionButton)`
  left: 0.25rem;
  bottom: 0.25rem;
  cursor: zoom-in;
  font-size: 1.625rem;
  padding: 1px 0 0 1.5px; /* Visually center the icon */
`;

export const DownloadButton = styled(ActionButton)`
  position: static;
  font-size: 1.375rem;
`;

export const CloseButton = styled(ActionButton)`
  position: static;
  font-size: 1.375rem;
`;

// Same as the zoom-image button, but on the right.
export const PlayVideoButton = styled(ActionButton)`
  right: 0.25rem;
  bottom: 0.25rem;
  cursor: pointer;

  /* Adjust icon size to match the zoom button's perceived size */
  font-size: 1.375rem;
`;
